// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gTJB","fullView":"styles_fullView__315fw"};